/* eslint-disable eqeqeq */
import { useState } from "react";
import { useForm } from "react-hook-form";
import { submitALoanFormOptions, lenderAccountSetupArr, lenderAccountSetupArrContinued} from "../SALForm/SalConstant"
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import FormBox from "../../components/FormBox/FormBox";

const LenderAccountSetupForm = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });
  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = (data) => {
      setSubmitLoading(true);
      const id = toast.loading("Loan Submission Pending");

      try {
        // const headers = {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // };
        // await axios.post(
        //   urls.submitaLoan.postSubmitaLoan(),
        //   {
        //     user_id: localStorage.getItem("apex_userid"),
        //     loan_submission_details: data,
        //   },
        //   headers
        // );
        toast.update(id, {
          render: "Loan Submitted Succesfuly",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        setSubmitLoading(false);
      } catch (error) {
        console.error(error);
      }
    
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h6>
              <a href="/submit-a-loan" style={{ textDecoration: "none" }}>
                Submit a Loan
              </a>{" "}
              / Form
            </h6>
          </div>
        </article>
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="row"></div>
            <h4 className="mt-5">New Lender Account Setup Form</h4>
            <form>
              <div className="loans-in-details mt-5">
                {lenderAccountSetupArr?.map((data, index) => {
                  return  <RenderComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                })}
                <h4 className="mt-5 mb-4">Lender Questionnaire</h4>
                <p className="mt-5 mb-4">To ensure that we are able to service your loans, we will need to review your Note, Deed or Mortgage, please email those documents to rjesena@superiorloanservicing.com</p>
                {lenderAccountSetupArrContinued?.map((data, index) => {
                  return  <RenderComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                })}
                <button onClick={handleSubmit(onSubmit)} className="btn btn-primary text-white">
                    Submit
                </button>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};
export default LenderAccountSetupForm;

const RenderComp = ({ options, ...props }) => {

  return (
    <div className="row">
      {options.map((data) =>
          <div className="col-6">
            <h4 className="mt-5 mb-4">{data.section}</h4>
            <FormBox {...props} options={data.arr} />
          </div>
      )}
    </div>
  );
};

